import { FC, useRef, useState } from 'react';
import { Maybe, TrackedProperty } from '../graphql.generated';
import type { PropertyDataForAnalytics } from '@zoopla/analytics/property-data';
import { useTrackPropertyContext } from './context/track-property-context';

import Button from './Button/Button';
import EditButton from './EditButton/EditButton';

type TrackPropertyProps = {
    analyticsData: PropertyDataForAnalytics;
    trackedProperty?: Maybe<TrackedProperty>;
    hideLabel?: boolean;
    isCalcShown?: boolean;
};

const TrackProperty: FC<TrackPropertyProps> = ({
    analyticsData,
    hideLabel
}) => {
    const [, setIsAuthModalShowing] = useState(false);
    const buttonRef = useRef<HTMLButtonElement | null>(null);

    const { state } = useTrackPropertyContext();

    if (!analyticsData?.uprn) return null;

    return (
        <>
            <Button
                trackedProperty={state}
                analyticsData={analyticsData}
                hideLabel={hideLabel}
                setIsAuthModalShowing={setIsAuthModalShowing}
                ref={buttonRef}
            />
            {state.isTracked && <EditButton analyticsData={analyticsData} />}
        </>
    );
};
export default TrackProperty;
